//https://cdn.haworth.com/haworth-configurator/0.0.33/assets/w-cf/scripts/utils.min.js
'use strict';
var egr,
  __extends =
    (this && this.__extends) ||
    (function () {
      var n = function (t, e) {
        return (n =
          Object.setPrototypeOf ||
          ({ __proto__: [] } instanceof Array &&
            function (t, e) {
              t.__proto__ = e;
            }) ||
          function (t, e) {
            for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
          })(t, e);
      };
      return function (t, e) {
        function r() {
          this.constructor = t;
        }
        n(t, e),
          (t.prototype =
            null === e
              ? Object.create(e)
              : ((r.prototype = e.prototype), new r()));
      };
    })(),
  __awaiter =
    (this && this.__awaiter) ||
    function (t, s, a, u) {
      return new (a = a || Promise)(function (r, e) {
        function n(t) {
          try {
            i(u.next(t));
          } catch (t) {
            e(t);
          }
        }
        function o(t) {
          try {
            i(u.throw(t));
          } catch (t) {
            e(t);
          }
        }
        function i(t) {
          var e;
          t.done
            ? r(t.value)
            : ((e = t.value) instanceof a
                ? e
                : new a(function (t) {
                    t(e);
                  })
              ).then(n, o);
        }
        i((u = u.apply(t, s || [])).next());
      });
    },
  __generator =
    (this && this.__generator) ||
    function (r, n) {
      var o,
        i,
        s,
        a = {
          label: 0,
          sent: function () {
            if (1 & s[0]) throw s[1];
            return s[1];
          },
          trys: [],
          ops: [],
        },
        t = { next: e(0), throw: e(1), return: e(2) };
      return (
        'function' == typeof Symbol &&
          (t[Symbol.iterator] = function () {
            return this;
          }),
        t
      );
      function e(e) {
        return function (t) {
          return (function (e) {
            if (o) throw new TypeError('Generator is already executing.');
            for (; a; )
              try {
                if (
                  ((o = 1),
                  i &&
                    (s =
                      2 & e[0]
                        ? i.return
                        : e[0]
                        ? i.throw || ((s = i.return) && s.call(i), 0)
                        : i.next) &&
                    !(s = s.call(i, e[1])).done)
                )
                  return s;
                switch (((i = 0), s && (e = [2 & e[0], s.value]), e[0])) {
                  case 0:
                  case 1:
                    s = e;
                    break;
                  case 4:
                    return a.label++, { value: e[1], done: !1 };
                  case 5:
                    a.label++, (i = e[1]), (e = [0]);
                    continue;
                  case 7:
                    (e = a.ops.pop()), a.trys.pop();
                    continue;
                  default:
                    if (
                      !(s = 0 < (s = a.trys).length && s[s.length - 1]) &&
                      (6 === e[0] || 2 === e[0])
                    ) {
                      a = 0;
                      continue;
                    }
                    if (3 === e[0] && (!s || (e[1] > s[0] && e[1] < s[3]))) {
                      a.label = e[1];
                      break;
                    }
                    if (6 === e[0] && a.label < s[1]) {
                      (a.label = s[1]), (s = e);
                      break;
                    }
                    if (s && a.label < s[2]) {
                      (a.label = s[2]), a.ops.push(e);
                      break;
                    }
                    s[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                e = n.call(r, a);
              } catch (t) {
                (e = [6, t]), (i = 0);
              } finally {
                o = s = 0;
              }
            if (5 & e[0]) throw e[1];
            return { value: e[0] ? e[1] : void 0, done: !0 };
          })([e, t]);
        };
      }
    };
!(function (t) {
  var e;
  (function (r) {
    function n(t, e) {
      return r.string.isNotNullOrEmpty(e)
        ? new Error(t + ':' + e)
        : new Error(t);
    }
    (r.ERR_FAILED = 'failed'),
      (r.ERR_INVALID_STATE = 'invalid state'),
      (r.ERR_INVALID_ARGUMENT = 'invalid argument'),
      (r.ERR_NOT_IMPLEMENTED = 'not implemented'),
      (r.ERR_NOT_AVAILABLE = 'not available'),
      (r.newError = n),
      (r.rejectError = function (t, e) {
        return Promise.reject(n(t, e));
      });
    var o,
      t =
        ((o = Error),
        __extends(i, o),
        Object.defineProperty(i.prototype, 'name', {
          get: function () {
            return null != this.mCustomName
              ? this.mCustomName
              : this.constructor.name;
          },
          set: function (t) {
            this.mCustomName = t;
          },
          enumerable: !1,
          configurable: !0,
        }),
        i);
    function i(t) {
      var e = o.call(this, t) || this;
      return Object.setPrototypeOf(e, i.prototype), e;
    }
    r.CustomError = t;
  })((e = t.wcf || (t.wcf = {})).utils || (e.utils = {}));
})((egr = egr || {})),
  (function (t) {
    var e, o, r;
    function n() {
      this.mData = {};
    }
    (e = t.wcf || (t.wcf = {})),
      (o = e.utils || (e.utils = {})),
      (n.prototype.clear = function () {
        this.mData = {};
      }),
      (n.prototype.setData = function (t, e, r) {
        var n;
        o.string.isNullOrEmpty(t) ||
          o.string.isNullOrEmpty(e) ||
          (void 0 !== r
            ? ((n = this.getGroup(t, !0))[e] = r)
            : null != (n = this.getGroup(t, !1)) &&
              e in n &&
              (delete n[e], this.hasKeys(n) || delete this.mData[t]));
      }),
      (n.prototype.getData = function (t, e) {
        if (!o.string.isNullOrEmpty(t) && !o.string.isNullOrEmpty(e)) {
          var r = this.getGroup(t, !1);
          if (null != r) {
            var n = r[e];
            return void 0 !== n ? n : void 0;
          }
        }
      }),
      (n.prototype.serialize = function () {
        return this.hasKeys(this.mData) ? this.mData : null;
      }),
      (n.prototype.deserialize = function (t) {
        return (this.mData = null != t ? t : {}), !0;
      }),
      (n.prototype.getGroup = function (t, e) {
        var r = this.mData[t];
        if (null != r) return r;
        if (e) {
          var n = {};
          return (this.mData[t] = n);
        }
      }),
      (n.prototype.hasKeys = function (t) {
        return null != t && 0 !== Object.keys(t).length;
      }),
      (r = n),
      (o.GroupedMap = r);
  })((egr = egr || {})),
  (function (t) {
    var e;
    (function (r) {
      var t =
        (Object.defineProperty(e.prototype, 'hasListeners', {
          get: function () {
            return 0 !== this.mListeners.length;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (e.prototype.addListener = function (t) {
          null != t &&
            (this.mListenersLocked
              ? this.addToLockQueue(!1, t)
              : this.mListeners.push(t));
        }),
        (e.prototype.removeListener = function (t) {
          null != t &&
            (this.mListenersLocked
              ? this.addToLockQueue(!0, t)
              : r.array.remove(this.mListeners, t));
        }),
        (e.prototype.addToLockQueue = function (t, e) {
          null == this.mLockQueue && (this.mLockQueue = new Array()),
            this.mLockQueue.push({ remove: t, listener: e });
        }),
        (e.prototype.processLockQueue = function () {
          if (null != this.mLockQueue) {
            for (var t = 0, e = this.mLockQueue; t < e.length; t++) {
              var r = e[t];
              r.remove
                ? this.removeListener(r.listener)
                : this.addListener(r.listener);
            }
            this.mLockQueue = null;
          }
        }),
        e);
      function e(t) {
        (this.mOwner = t),
          (this.mListeners = new Array()),
          (this.mLockQueue = null),
          (this.mListenersLocked = !1);
      }
      r.AbstractListenableEvent = t;
      var n,
        o =
          (__extends(i, (n = t)),
          (i.prototype.trigger = function (t) {
            if (0 !== this.mListeners.length) {
              this.mListenersLocked = !0;
              try {
                for (var e = 0, r = this.mListeners; e < r.length; e++)
                  (0, r[e])(t, this.mOwner);
              } finally {
                (this.mListenersLocked = !1), this.processLockQueue();
              }
            }
          }),
          i);
      function i() {
        return (null !== n && n.apply(this, arguments)) || this;
      }
      r.ListenableEvent = o;
      var s,
        a =
          (__extends(u, (s = t)),
          (u.prototype.trigger = function (o) {
            return __awaiter(this, void 0, void 0, function () {
              var e, r, n;
              return __generator(this, function (t) {
                switch (t.label) {
                  case 0:
                    return 0 === this.mListeners.length
                      ? [2]
                      : [4, this.mTriggerLock.acquireLock()];
                  case 1:
                    (e = t.sent()), (t.label = 2);
                  case 2:
                    t.trys.push([2, , 7, 8]),
                      (this.mListenersLocked = !0),
                      (r = 0),
                      (n = this.mListeners),
                      (t.label = 3);
                  case 3:
                    return r < n.length
                      ? [4, (0, n[r])(o, this.mOwner)]
                      : [3, 6];
                  case 4:
                    t.sent(), (t.label = 5);
                  case 5:
                    return r++, [3, 3];
                  case 6:
                    return [3, 8];
                  case 7:
                    return (
                      (this.mListenersLocked = !1),
                      this.processLockQueue(),
                      e.unlock(),
                      [7]
                    );
                  case 8:
                    return [2];
                }
              });
            });
          }),
          u);
      function u(t) {
        var e = s.call(this, t) || this;
        return (e.mTriggerLock = new r.async.Lock()), e;
      }
      r.AsyncListenableEvent = a;
    })((e = t.wcf || (t.wcf = {})).utils || (e.utils = {}));
  })((egr = egr || {})),
  (function (t) {
    var e, r, n;
    function o() {}
    (e = t.wcf || (t.wcf = {})),
      (r = e.utils || (e.utils = {})),
      (o.debug = function (t) {
        console.log(o.FormatMsg(t));
      }),
      (o.info = function (t) {
        console.info(o.FormatMsg(t));
      }),
      (o.warn = function (t) {
        o.eventWarn.trigger(t), console.warn(o.FormatMsg(t));
      }),
      (o.error = function (t, e) {
        o.eventError.trigger({ message: t, error: e });
        var r = o.FormatMsg(t);
        null != e &&
          ((r += ' '),
          e instanceof Error
            ? ((r += e), null != e.stack && (r += ' Stack: ' + e.stack))
            : (r += 'Error: ' + e)),
          console.error(r);
      }),
      (o.FormatMsg = function (t) {
        var e = new Date();
        return (
          '[W-CF ' +
          e.getHours() +
          ':' +
          e.getMinutes() +
          ':' +
          e.getSeconds() +
          ':' +
          e.getMilliseconds() +
          '] ' +
          t
        );
      }),
      (o.eventWarn = new r.ListenableEvent(null)),
      (o.eventError = new r.ListenableEvent(null)),
      (n = o),
      (r.Log = n);
  })((egr = egr || {})),
  (function (t) {
    var e, r, n;
    function o(t, e) {
      void 0 === t && (t = null),
        void 0 === e && (e = !1),
        (this.mSectionSize = 0),
        (this.mSectionProgress = 0),
        (this.mBaseProgress = 0),
        (this.mProgress = 0),
        (this.mCallback = t),
        e || this.startSection(100);
    }
    (e = t.wcf || (t.wcf = {})),
      (r = e.utils || (e.utils = {})),
      Object.defineProperty(o.prototype, 'progress', {
        get: function () {
          return this.mProgress;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(o.prototype, 'sectionProgress', {
        get: function () {
          return this.mSectionProgress;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (o.prototype.setProgress = function (t) {
        var e;
        this.mSectionProgress != t &&
          ((this.mSectionProgress = t),
          (e = this.mSectionProgress * (this.mSectionSize / 100)),
          (this.mProgress = this.mBaseProgress + e),
          null != this.mCallback && this.mCallback(this.mProgress));
      }),
      (o.prototype.startSection = function (t) {
        this.finishSection(), (this.mSectionSize = t);
      }),
      (o.prototype.finishSection = function () {
        this.setProgress(100),
          (this.mBaseProgress += this.mSectionSize),
          (this.mProgress = this.mBaseProgress),
          (this.mSectionSize = 0),
          (this.mSectionProgress = 0);
      }),
      (n = o),
      (r.Progress = n);
  })((egr = egr || {})),
  (function (t) {
    var e;
    (e = t.wcf || (t.wcf = {})).utils || (e.utils = {});
  })((egr = egr || {})),
  (function (t) {
    var e, s, r;
    (e = t.wcf || (t.wcf = {})),
      (s = e.utils || (e.utils = {})),
      ((r = s.array || (s.array = {})).isArray = function (t) {
        return Array.isArray(t);
      }),
      (r.remove = function (t, e) {
        if (null == t) return !1;
        var r = t.indexOf(e);
        return -1 !== r && (t.splice(r, 1), !0);
      }),
      (r.addElements = function (t, e) {
        null != t && null != e && t.push.apply(t, e);
      }),
      (r.insertElements = function (t, e, r) {
        if (null != t && null != e)
          for (var n = 0; n < e.length; ++n) t.splice(r + n, 0, e[n]);
      }),
      (r.clone = function (t) {
        if (null == t) throw new Error(s.ERR_INVALID_ARGUMENT);
        return t.slice(0);
      }),
      (r.contains = function (t, e) {
        if (null == t) throw new Error(s.ERR_INVALID_ARGUMENT);
        return 0 <= t.indexOf(e);
      }),
      (r.clear = function (t) {
        null != t && (t.length = 0);
      }),
      (r.unique = function (t) {
        if (null == t) throw new Error(s.ERR_INVALID_ARGUMENT);
        return Array.from(new Set(t));
      }),
      (r.chunk = function (t, e) {
        if (e < 1) throw new Error(s.ERR_INVALID_ARGUMENT);
        for (var r = t.length, n = new Array(), o = 0; o < r; o += e) {
          var i = t.slice(o, o + e);
          n.push(i);
        }
        return n;
      });
  })((egr = egr || {})),
  (function (t) {
    var e, i, r, s;
    function n(t) {
      if (null == t) throw new Error(i.ERR_INVALID_ARGUMENT);
      for (
        var e = '', r = new Uint8Array(t), n = r.byteLength, o = 0;
        o < n;
        o++
      )
        e += String.fromCharCode(r[o]);
      return btoa(e);
    }
    function a(t) {
      if (null == t) throw new Error(i.ERR_INVALID_ARGUMENT);
      for (
        var e = new Uint8Array(t), r = e.byteLength, n = '', o = 0;
        o < r;
        o++
      )
        n += e[o].toString(16).padStart(2, '0');
      return n;
    }
    function o(t) {
      if (i.string.isNullOrEmpty(t)) throw new Error(i.ERR_INVALID_ARGUMENT);
      for (
        var e = atob(t), r = e.length, n = new Uint8Array(r), o = 0;
        o < r;
        o++
      )
        n[o] = e.charCodeAt(o);
      return n.buffer;
    }
    (e = t.wcf || (t.wcf = {})),
      (i = e.utils || (e.utils = {})),
      ((r = i.arraybuffer || (i.arraybuffer = {})).toBase64 = n),
      (r.toHex = a),
      (r.toDataUri = function (t, e) {
        if (null == t || i.string.isNullOrEmpty(e))
          throw new Error(i.ERR_INVALID_ARGUMENT);
        return 'data:' + e + ';base64,' + n(t);
      }),
      (r.fromBase64 = o),
      (r.fromDataUri = function (t) {
        if (!i.string.isDataUri(t)) throw new Error(i.ERR_INVALID_ARGUMENT);
        return o(t.split(',')[1]);
      }),
      (r.fromBlob = function (n) {
        return null == n
          ? Promise.reject(new Error(i.ERR_INVALID_ARGUMENT))
          : new Promise(function (t, e) {
              var r = new FileReader();
              (r.onload = function () {
                t(r.result);
              }),
                (r.onerror = function () {
                  null != r.error
                    ? e(new Error('Failed to read from blob: ' + r.error.name))
                    : e(new Error('Failed to read from blob.'));
                }),
                r.readAsArrayBuffer(n);
            });
      }),
      (r.hash = function (n, o) {
        return __awaiter(this, void 0, void 0, function () {
          var e, r;
          return __generator(this, function (t) {
            switch (t.label) {
              case 0:
                return (
                  null != window.crypto
                    ? null != window.crypto.subtle &&
                      (e = crypto.subtle.digest(o, n))
                    : null != window.msCrypto &&
                      'SHA-512' !== o &&
                      ((r = window.msCrypto.subtle.digest(o, n)),
                      (e = new Promise(function (e, t) {
                        r.oncomplete = function (t) {
                          return e(t.target.result);
                        };
                      }))),
                  null == e ? [3, 2] : [4, e]
                );
              case 1:
                return [2, a(t.sent())];
              case 2:
                return [
                  2,
                  (function (n, o) {
                    return __awaiter(this, void 0, void 0, function () {
                      var e, r;
                      return __generator(this, function (t) {
                        switch (t.label) {
                          case 0:
                            if (null != window.jsSHA) return [3, 2];
                            if (i.string.isNullOrEmpty(i.wcfLibsPath))
                              throw i.newError(
                                i.ERR_INVALID_STATE,
                                'utils.wcfLibsPath not defined'
                              );
                            return (
                              null == s &&
                                (s = i.dom.loadScript(
                                  i.string.joinPath(
                                    i.wcfLibsPath,
                                    '/jssha/sha.js?wcf_v=6.0.0'
                                  )
                                )),
                              [4, s]
                            );
                          case 1:
                            t.sent(), (t.label = 2);
                          case 2:
                            if (null == (e = window.jsSHA))
                              throw i.newError(
                                i.ERR_INVALID_STATE,
                                'jsSHA not defined'
                              );
                            return (
                              (r = new e(
                                o,
                                n instanceof ArrayBuffer
                                  ? 'ARRAYBUFFER'
                                  : 'UINT8ARRAY'
                              )).update(n),
                              [2, r.getHash('HEX')]
                            );
                        }
                      });
                    });
                  })(n, o),
                ];
            }
          });
        });
      });
  })((egr = egr || {})),
  (function (t) {
    var e, y;
    (e = t.wcf || (t.wcf = {})),
      (function (g) {
        var r,
          v = ((r = y.CustomError), __extends(n, r), n);
        function n(t) {
          var e = r.call(this, 'request aborted: ' + t) || this;
          return Object.setPrototypeOf(e, n.prototype), e;
        }
        g.AjaxAbortedError = v;
        var o,
          t = ((o = y.CustomError), __extends(i, o), i);
        function i(t) {
          var e = o.call(this, 'request timeout: ' + t) || this;
          return Object.setPrototypeOf(e, i.prototype), e;
        }
        g.AjaxTimeoutError = t;
        var s,
          w = ((s = y.CustomError), __extends(a, s), a);
        function a(t) {
          var e = s.call(this, 'request connection interrupted: ' + t) || this;
          return Object.setPrototypeOf(e, a.prototype), e;
        }
        (g.AjaxConnectionError = w),
          (g.ajaxErrorHandler = null),
          (g.ajaxResolvedEvent = null),
          (g.ajaxRejectedEvent = null),
          (g.ajaxDefaultOptions = {
            cache: !0,
            dataType: 'post',
            responseType: 'auto',
            headers: {},
            user: '',
            password: '',
            withCredentials: !1,
            timeout: 3e4,
            retryAttempts: 3,
            ignoreGlobalErrorHandler: !1,
          }),
          (g.ajaxGetRetryDelay = function (t) {
            return 200 * t;
          }),
          (g.ajax = function (t, e, r, n, a, u) {
            function l() {
              return { url: e, method: t, data: r, options: n };
            }
            function c(t, e, r) {
              null != g.ajaxRejectedEvent && g.ajaxRejectedEvent(l(), t.xhr),
                r(e);
            }
            var o,
              i,
              h = null == n ? {} : n,
              f =
                null !== (o = h.retryAttempts) && void 0 !== o
                  ? o
                  : g.ajaxDefaultOptions.retryAttempts,
              m =
                null !== (i = h.ignoreGlobalErrorHandler) && void 0 !== i
                  ? i
                  : g.ajaxDefaultOptions.ignoreGlobalErrorHandler,
              p = null,
              d = function (n, o, i, s) {
                (p = new g.AjaxRequest(t, e, r, h, u))
                  .execute()
                  .then(function (t) {
                    (p = null) != g.ajaxResolvedEvent &&
                      g.ajaxResolvedEvent(l(), t.xhr),
                      n(t.response);
                  })
                  .catch(function (t) {
                    var e, r;
                    (p = null),
                      t.error instanceof v
                        ? o(t.error)
                        : t.error instanceof w && s < f
                        ? setTimeout(function () {
                            d(n, o, i + 1, s + 1);
                          }, g.ajaxGetRetryDelay(s + 1))
                        : ((e = (function (t, e) {
                            var r =
                                t.error instanceof Error
                                  ? t.error.message
                                  : t.error,
                              n = null;
                            null != e && (n = e(t.error, t.xhr, t.response));
                            null == n &&
                              ((n =
                                '[' + t.xhr.status + '] ' + t.xhr.statusText),
                              y.string.isNotNullOrEmpty(r) && (n += ' - ' + r));
                            return n instanceof Error ? n : Error(n);
                          })(t, a)),
                          null == g.ajaxErrorHandler || m
                            ? c(t, e, o)
                            : ((r = {
                                status: t.xhr.status,
                                textStatus: t.xhr.statusText,
                                errorThrown: t.error,
                                responseError: e,
                                requestInfo: l(),
                                retryCount: i,
                                retry: function () {
                                  return d(n, o, i + 1, 0);
                                },
                                reject: function () {
                                  return c(t, e, o);
                                },
                              }),
                              g.ajaxErrorHandler(r)));
                  });
              },
              s = new Promise(function (t, e) {
                d(t, e, 0, 0);
              });
            return (
              (s.abort = function () {
                null != p && p.abort();
              }),
              s
            );
          });
      })((y = e.utils || (e.utils = {})).async || (y.async = {}));
  })((egr = egr || {})),
  (function (t) {
    var e, n, c, r;
    function h(t, e, r, n, o) {
      var i = this;
      (this.onXhrError = function () {
        i.mAborted ||
          (i.internal_abort(!1),
          i.mPromiseReject({
            error: new c.AjaxConnectionError(i.mUrl),
            xhr: i.mXhr,
            response: null,
          }));
      }),
        (this.onXhrTimeout = function () {
          i.mAborted ||
            (i.internal_abort(!1),
            i.mPromiseReject({
              error: new c.AjaxTimeoutError(i.mUrl),
              xhr: i.mXhr,
              response: null,
            }));
        }),
        (this.onXhrLoad = function () {
          var e;
          if (null != i.mXhr) {
            if (((i.mSending = !1), !i.mAborted))
              try {
                if (i.mNativeResponseParsing) {
                  if ('response' in i.mXhr && null === i.mXhr.response)
                    throw 'The request response is empty';
                  e = i.mXhr.response;
                } else {
                  var t,
                    r = i.mOptions.responseType;
                  switch (
                    ('auto' === r &&
                      (r =
                        -1 <
                        (t =
                          i.mXhr.getResponseHeader('Content-Type') ||
                          '').indexOf(h.MIME_TYPES.json)
                          ? 'json'
                          : -1 < t.indexOf(h.MIME_TYPES.xml)
                          ? 'xml'
                          : 'text'),
                    r)
                  ) {
                    case 'json':
                      if (i.mXhr.responseText.length)
                        try {
                          e = JSON.parse(i.mXhr.responseText);
                        } catch (t) {
                          throw 'Error while parsing JSON body : ' + t;
                        }
                      break;
                    case 'xml':
                      try {
                        e = new DOMParser().parseFromString(
                          i.mXhr.responseText,
                          'text/xml'
                        );
                      } catch (t) {
                        e = void 0;
                      }
                      if (
                        !e ||
                        !e.documentElement ||
                        e.getElementsByTagName('parsererror').length
                      )
                        throw 'Invalid XML';
                      break;
                    default:
                      e = i.mXhr.responseText;
                  }
                }
                if (
                  'status' in i.mXhr &&
                  !/^2|1223/.test(i.mXhr.status.toString())
                )
                  throw i.mXhr.status + ' (' + i.mXhr.statusText + ')';
                i.mPromiseResolve({ xhr: i.mXhr, response: e });
              } catch (t) {
                i.mPromiseReject({ error: t, xhr: i.mXhr, response: e });
              }
          } else console.error('Invalid state, xhr = null');
        }),
        (this.mMethod = t.toUpperCase()),
        (this.mUrl = e),
        (this.mData = void 0 === r ? null : r),
        (this.mXhr = null),
        (this.mAborted = !1),
        (this.mSending = !1),
        (this.mNativeResponseParsing = !1),
        (this.mBeforeCallback = o),
        (this.mOptions = Object.assign({}, c.ajaxDefaultOptions)),
        (this.mOptions.headers = Object.assign(
          {},
          c.ajaxDefaultOptions.headers
        ));
      var s = n;
      for (var a in s) {
        var u = s[a];
        if (null != u)
          if ('headers' === a) for (var l in u) this.mOptions[a][l] = u[l];
          else this.mOptions[a] = u;
      }
      this.prepareData(), this.prepareHeaders(), this.prepareUrl();
    }
    (e = t.wcf || (t.wcf = {})),
      (n = e.utils || (e.utils = {})),
      (c = n.async || (n.async = {})),
      (h.prototype.execute = function () {
        var r = this,
          t = new Promise(function (t, e) {
            (r.mPromiseReject = e), (r.mPromiseResolve = t);
          });
        return this.send(), t;
      }),
      (h.prototype.abort = function () {
        this.internal_abort(!0);
      }),
      (h.prototype.prepareData = function () {
        if (
          (this.mData instanceof ArrayBuffer
            ? (this.mOptions.dataType = 'arraybuffer')
            : this.mData instanceof Blob
            ? (this.mOptions.dataType = 'blob')
            : this.mData instanceof Document
            ? (this.mOptions.dataType = 'document')
            : this.mData instanceof FormData &&
              (this.mOptions.dataType = 'formdata'),
          null !== this.mData)
        )
          switch (this.mOptions.dataType) {
            case 'json':
              this.mData = JSON.stringify(this.mData);
              break;
            case 'post':
            case 'queryString':
              this.mData = this.getQueryString(this.mData);
          }
      }),
      (h.prototype.prepareHeaders = function () {
        function t(t, e) {
          t in r || (r[t] = e);
        }
        function e(t, e, r) {
          return e + r.toUpperCase();
        }
        var r = {},
          n = this.mUrl.match(/\/\/(.+?)\//),
          o = n && !!n[1] && n[1] != location.host;
        for (var i in this.mOptions.headers)
          r[i.replace(/(^|-)([^-])/g, e)] = this.mOptions.headers[i];
        'GET' !== this.mMethod &&
          this.mOptions.dataType in h.MIME_TYPES &&
          h.MIME_TYPES[this.mOptions.dataType] &&
          t('Content-Type', h.MIME_TYPES[this.mOptions.dataType]),
          t(
            'Accept',
            this.mOptions.responseType in h.ACCEPT
              ? h.ACCEPT[this.mOptions.responseType]
              : '*/*'
          ),
          o || t('X-Requested-With', 'XMLHttpRequest'),
          this.mOptions.cache || t('Cache-Control', 'no-cache'),
          (this.mOptions.headers = r);
      }),
      (h.prototype.prepareUrl = function () {
        ('GET' != this.mMethod && 'queryString' != this.mOptions.dataType) ||
          null == this.mData ||
          !n.string.isString(this.mData) ||
          (this.mUrl += (/\?/.test(this.mUrl) ? '&' : '?') + this.mData);
      }),
      (h.prototype.send = function () {
        if (!this.mSending && !this.mAborted) {
          for (var t in ((this.mSending = !0),
          (this.mXhr = new XMLHttpRequest()),
          this.mXhr.open(
            this.mMethod,
            this.mUrl,
            !0,
            this.mOptions.user,
            this.mOptions.password
          ),
          (this.mXhr.withCredentials = this.mOptions.withCredentials),
          this.mOptions.headers))
            this.mOptions.headers[t] &&
              this.mXhr.setRequestHeader(t, this.mOptions.headers[t]);
          if (
            'auto' != this.mOptions.responseType &&
            'xml' != this.mOptions.responseType
          )
            try {
              (this.mXhr.responseType = this.mOptions.responseType),
                (this.mNativeResponseParsing =
                  this.mXhr.responseType == this.mOptions.responseType);
            } catch (t) {}
          var e;
          (this.mXhr.onload = this.onXhrLoad),
            (this.mXhr.onerror = this.onXhrError),
            (this.mXhr.timeout = this.mOptions.timeout),
            (this.mXhr.ontimeout = this.onXhrTimeout),
            'auto' != this.mOptions.responseType &&
              'overrideMimeType' in this.mXhr &&
              null != (e = h.MIME_TYPES[this.mOptions.responseType]) &&
              this.mXhr.overrideMimeType(e),
            null != this.mBeforeCallback && this.mBeforeCallback(this.mXhr),
            this.mXhr.send('GET' != this.mMethod ? this.mData : null);
        }
      }),
      (h.prototype.internal_abort = function (t) {
        this.mAborted ||
          (null != this.mXhr && 4 != this.mXhr.readyState && this.mXhr.abort(),
          (this.mSending = !1),
          (this.mAborted = !0),
          t &&
            null != this.mXhr &&
            this.mPromiseReject({
              error: new c.AjaxAbortedError(this.mUrl),
              xhr: this.mXhr,
              response: null,
            }));
      }),
      (h.prototype.getQueryString = function (t) {
        if (n.string.isString(t)) return t;
        if (n.object.isPlainObject(t)) {
          var e = new URLSearchParams();
          for (var r in t) e.append(r, t[r]);
          return e.toString();
        }
        return '';
      }),
      (h.MIME_TYPES = {
        text: '*/*',
        xml: 'text/xml',
        json: 'application/json',
        post: 'application/x-www-form-urlencoded',
        document: 'text/html',
      }),
      (h.ACCEPT = {
        text: '*/*',
        xml: 'application/xml; q=1.0, text/xml; q=0.8, */*; q=0.1',
        json: 'application/json; q=1.0, text/*; q=0.8, */*; q=0.1',
      }),
      (r = h),
      (c.AjaxRequest = r);
  })((egr = egr || {})),
  (function (t) {
    var e, a, n;
    (e = t.wcf || (t.wcf = {})),
      (a = e.utils || (e.utils = {})),
      ((n = a.async || (a.async = {})).forEach = function (r, t, n) {
        if (null == r) return Promise.reject(new Error(a.ERR_INVALID_ARGUMENT));
        if (r.length <= 0) return Promise.resolve(!0);
        function e(t, e) {
          return t.then(function (t) {
            return !!t && n(e, r[e]);
          });
        }
        var o = Promise.resolve(!0);
        if (t) for (var i = r.length - 1; 0 <= i; --i) o = e(o, i);
        else for (i = 0; i < r.length; ++i) o = e(o, i);
        return o;
      }),
      (n.forEachParallel = function (t, o, e) {
        var i,
          r,
          s = this;
        return null == t
          ? Promise.reject(new Error(a.ERR_INVALID_ARGUMENT))
          : t.length <= 0
          ? Promise.resolve(new Array())
          : ((r =
              null == e || e < 1 || t.length <= e
                ? t.map(function (t, e) {
                    return o(e, t);
                  })
                : ((i = new n.Lock(e)),
                  t.map(function (r, n) {
                    return __awaiter(s, void 0, void 0, function () {
                      var e;
                      return __generator(this, function (t) {
                        switch (t.label) {
                          case 0:
                            return [4, i.acquireLock()];
                          case 1:
                            (e = t.sent()), (t.label = 2);
                          case 2:
                            return t.trys.push([2, , 4, 5]), [4, o(n, r)];
                          case 3:
                            return [2, t.sent()];
                          case 4:
                            return e.unlock(), [7];
                          case 5:
                            return [2];
                        }
                      });
                    });
                  }))),
            Promise.all(r));
      });
  })((egr = egr || {})),
  (function (t) {
    var e, r, n, o;
    function i(t) {
      var r = this;
      (this.onTimeout = function () {
        var t = r.mPromiseResolve,
          e = r.mPromiseReject;
        (r.mPromise = null),
          (r.mPromiseResolve = null),
          (r.mPromiseReject = null) != t &&
            null != e &&
            r.mTask().then(t).catch(e);
      }),
        (this.mTask = t),
        (this.mTimer = new n.Timer(this.onTimeout));
    }
    (e = t.wcf || (t.wcf = {})),
      (r = e.utils || (e.utils = {})),
      (n = r.async || (r.async = {})),
      (i.prototype.run = function (t, e) {
        var r = this;
        return (
          void 0 === e && (e = !1),
          null == this.mPromise &&
            (this.mPromise = new Promise(function (t, e) {
              (r.mPromiseResolve = t), (r.mPromiseReject = e);
            })),
          this.mTimer.start(t, e),
          this.mPromise
        );
      }),
      (o = i),
      (n.DelayedTask = o);
  })((egr = egr || {})),
  (function (t) {
    var e, r, n, o;
    function i(t) {
      var e = this;
      void 0 === t && (t = 1),
        (this.onUnlock = function (t) {
          void 0 === t && (t = !1),
            e.mCurrentRunningTasks--,
            t
              ? setTimeout(function () {
                  e.resolveNext();
                })
              : e.resolveNext();
        }),
        (this.mMaxConcurrentTasks = t),
        (this.mCurrentRunningTasks = 0),
        (this.mPromiseQueue = new Array()),
        (this.mLockContext = { unlock: this.onUnlock }),
        (this.mWaitPromise = null),
        (this.mWaitPromiseResolve = null);
    }
    (e = t.wcf || (t.wcf = {})),
      (r = e.utils || (e.utils = {})),
      (n = r.async || (r.async = {})),
      Object.defineProperty(i.prototype, 'isLocked', {
        get: function () {
          return this.mCurrentRunningTasks >= this.mMaxConcurrentTasks;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (i.prototype.acquireLock = function () {
        var r = this,
          t = new Promise(function (t, e) {
            r.mPromiseQueue.push(t);
          });
        return this.resolveNext(), t;
      }),
      (i.prototype.waitWhileLocked = function () {
        var r = this;
        return this.isLocked
          ? (null == this.mWaitPromise &&
              (this.mWaitPromise = new Promise(function (t, e) {
                r.mWaitPromiseResolve = t;
              })),
            this.mWaitPromise)
          : Promise.resolve();
      }),
      (i.prototype.resolveNext = function () {
        var t;
        this.isLocked ||
          (this.resolveWaitPromise(),
          void 0 !== (t = this.mPromiseQueue.shift()) &&
            (this.mCurrentRunningTasks++, t(this.mLockContext)));
      }),
      (i.prototype.resolveWaitPromise = function () {
        null != this.mWaitPromiseResolve &&
          ((this.mWaitPromise = null),
          this.mWaitPromiseResolve(),
          (this.mWaitPromiseResolve = null));
      }),
      (o = i),
      (n.Lock = o);
  })((egr = egr || {})),
  (function (t) {
    var e, n, r, o;
    function i(t) {
      this.mLock = null != t ? t : new r.Lock();
    }
    (e = t.wcf || (t.wcf = {})),
      (n = e.utils || (e.utils = {})),
      (r = n.async || (n.async = {})),
      Object.defineProperty(i.prototype, 'hasPendingTasks', {
        get: function () {
          return this.mLock.isLocked;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (i.prototype.addTask = function (r) {
        return __awaiter(this, void 0, void 0, function () {
          var e;
          return __generator(this, function (t) {
            switch (t.label) {
              case 0:
                return null == r
                  ? [2, Promise.reject(new Error(n.ERR_INVALID_ARGUMENT))]
                  : [4, this.mLock.acquireLock()];
              case 1:
                (e = t.sent()), (t.label = 2);
              case 2:
                return t.trys.push([2, , 4, 5]), [4, r()];
              case 3:
                return [2, t.sent()];
              case 4:
                return e.unlock(!0), [7];
              case 5:
                return [2];
            }
          });
        });
      }),
      (o = i),
      (r.TaskQueue = o);
  })((egr = egr || {})),
  (function (t) {
    var e, r, n, o;
    function i(t) {
      var e = this;
      (this.onTimeout = function () {
        (e.mTimer = null), e.mHandler();
      }),
        (this.mHandler = t);
    }
    (e = t.wcf || (t.wcf = {})),
      (r = e.utils || (e.utils = {})),
      (n = r.async || (r.async = {})),
      Object.defineProperty(i.prototype, 'isRunning', {
        get: function () {
          return null != this.mTimer;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (i.prototype.start = function (t, e) {
        if ((void 0 === e && (e = !1), this.isRunning)) {
          if (!e) return;
          this.stop();
        }
        this.mTimer = setTimeout(this.onTimeout, t);
      }),
      (i.prototype.stop = function () {
        null != this.mTimer &&
          (clearTimeout(this.mTimer), (this.mTimer = null));
      }),
      (o = i),
      (n.Timer = o);
  })((egr = egr || {})),
  (function (t) {
    var e, r;
    (e = t.wcf || (t.wcf = {})),
      ((
        (r = e.utils || (e.utils = {})).boolean || (r.boolean = {})
      ).isBoolean = function (t) {
        return 'boolean' == typeof t || t instanceof Boolean;
      });
  })((egr = egr || {})),
  (function (t) {
    var e, l, c;
    function r(s, t) {
      var a = l.async.ajaxDefaultOptions.retryAttempts,
        u = function (e, r, n, o) {
          var i = t(
            function () {
              return e();
            },
            function () {
              var t;
              document.body.removeChild(i),
                o < a
                  ? setTimeout(function () {
                      u(e, r, n + 1, o + 1);
                    }, l.async.ajaxGetRetryDelay(o + 1))
                  : null != c.loadContentErrorHandler
                  ? ((t = {
                      url: s,
                      retryCount: n,
                      retry: function () {
                        return u(e, r, n + 1, 0);
                      },
                      reject: function () {
                        return r(new Error('Failed to load content: ' + s));
                      },
                    }),
                    c.loadContentErrorHandler(t))
                  : r(new Error('Failed to load content: ' + s));
            }
          );
          document.body.appendChild(i);
        };
      return new Promise(function (t, e) {
        u(t, e, 0, 0);
      });
    }
    (e = t.wcf || (t.wcf = {})),
      (l = e.utils || (e.utils = {})),
      ((c = l.dom || (l.dom = {})).loadContentErrorHandler = null),
      (c.loadContentAsBlobUrl = function (r) {
        return __awaiter(this, void 0, void 0, function () {
          var e;
          return __generator(this, function (t) {
            switch (t.label) {
              case 0:
                return [
                  4,
                  l.async.ajax('GET', r, void 0, { responseType: 'blob' }),
                ];
              case 1:
                return (e = t.sent()), [2, URL.createObjectURL(e)];
            }
          });
        });
      }),
      (c.loadScript = function (n, o) {
        return (
          void 0 === o && (o = !0),
          r(n, function (t, e) {
            var r = document.createElement('script');
            return (
              (r.type = 'text/javascript'),
              (r.onload = t),
              (r.onerror = e),
              (r.async = o),
              (r.src = n),
              r
            );
          })
        );
      }),
      (c.loadStyleSheet = function (n) {
        return r(n, function (t, e) {
          var r = document.createElement('link');
          return (
            (r.rel = 'stylesheet'),
            (r.type = 'text/css'),
            (r.onload = t),
            (r.onerror = e),
            (r.href = n),
            r
          );
        });
      }),
      (c.submitForm = function (t, e, r) {
        var n = document.createElement('form');
        n.setAttribute('method', t),
          n.setAttribute('action', e),
          r.forEach(function (t, e) {
            var r = document.createElement('input');
            r.setAttribute('type', 'hidden'),
              r.setAttribute('name', e),
              r.setAttribute('value', t),
              n.appendChild(r);
          }),
          document.body.appendChild(n),
          n.submit();
      });
  })((egr = egr || {})),
  (function (t) {
    var e, a, r;
    function n(t, e) {
      var r = document.createElement('canvas'),
        n = r.getContext('2d');
      if (null == n)
        throw a.newError(a.ERR_FAILED, 'Failed to get 2d context.');
      var o,
        i = e.width,
        s = e.height;
      return (
        !1 !== e.keepAspectRatio &&
          (i < s * (o = t.width / t.height) ? (s = i / o) : (i = s * o)),
        (r.width = i),
        (r.height = s),
        n.drawImage(t, 0, 0, r.width, r.height),
        r
      );
    }
    function o(t, e) {
      var n = null != e ? e : 'image/png';
      if (null != t.toBlob)
        return new Promise(function (e, r) {
          try {
            t.toBlob(function (t) {
              null != t ? e(t) : r(a.newError(a.ERR_FAILED, 'toBlob failed'));
            }, n);
          } catch (t) {
            r(t);
          }
        });
      var r = t.toDataURL(n),
        o = a.arraybuffer.fromDataUri(r);
      return Promise.resolve(new Blob([o], { type: n }));
    }
    (e = t.wcf || (t.wcf = {})),
      (a = e.utils || (e.utils = {})),
      ((r = a.image || (a.image = {})).load = function (i) {
        return new Promise(function (t, e) {
          var r = i,
            n = !1;
          a.string.isString(r) || ((r = URL.createObjectURL(i)), (n = !0));
          var o = new Image();
          (o.onload = function () {
            n && URL.revokeObjectURL(r), t(o);
          }),
            (o.onerror = function () {
              n && URL.revokeObjectURL(r),
                e(a.newError(a.ERR_FAILED, 'Failed to load image: ' + i));
            }),
            (o.src = r);
        });
      }),
      (r.resizeToCanvas = n),
      (r.resizeToDataUri = function (t, e) {
        return n(t, e).toDataURL(e.mimeType);
      }),
      (r.resizeToBlob = function (t, e) {
        return o(n(t, e), e.mimeType);
      }),
      (r.canvasToBlob = o);
  })((egr = egr || {})),
  (function (t) {
    var e, r, n;
    function o(t, e, r) {
      return void 0 === r && (r = n.EPSILON), Math.abs(t - e) <= r;
    }
    (e = t.wcf || (t.wcf = {})),
      (r = e.utils || (e.utils = {})),
      ((n = r.math || (r.math = {})).EPSILON = 1e-5),
      (n.PI_MUL2 = 2 * Math.PI),
      (n.PI_DIV2 = Math.PI / 2),
      (n.PI_DIV4 = Math.PI / 4),
      (n.FACTOR_DEG_TO_RAD = Math.PI / 180),
      (n.FACTOR_RAD_TO_DEG = 180 / Math.PI),
      (n.eq = o),
      (n.geq = function (t, e, r) {
        return void 0 === r && (r = n.EPSILON), e < t || o(t, e, r);
      }),
      (n.leq = function (t, e, r) {
        return void 0 === r && (r = n.EPSILON), t < e || o(t, e, r);
      }),
      (n.clamp = function (t, e, r) {
        return Math.min(Math.max(t, e), r);
      }),
      (n.roundTo = function (t, e) {
        if (0 === e) return Math.round(t);
        if (isNaN(t)) return NaN;
        var r = t.toString().split('e'),
          r = Math.round(Number(r[0] + 'e' + (r[1] ? Number(r[1]) + e : e)))
            .toString()
            .split('e');
        return Number(r[0] + 'e' + (r[1] ? Number(r[1]) - e : -e));
      }),
      (n.radToDeg = function (t) {
        return t * n.FACTOR_RAD_TO_DEG;
      }),
      (n.degToRad = function (t) {
        return t * n.FACTOR_DEG_TO_RAD;
      });
  })((egr = egr || {})),
  (function (t) {
    var e, u, r, n;
    function l(t) {
      if (null == t) throw new Error(u.ERR_INVALID_ARGUMENT);
      var e = (e = t.trim()).replace(',', '.'),
        r = Number.parseFloat(e);
      return null == r || isNaN(r) ? null : r;
    }
    function c(t, e, r) {
      return (t * o(e)) / o(r);
    }
    function o(t) {
      switch (t) {
        case 0:
          return 10;
        case 1:
          return 100;
        case 2:
          return 254;
        case 3:
          return 3048;
        case 4:
          return 1e4;
        case 5:
          return 1e7;
        default:
          return 0;
      }
    }
    (e = t.wcf || (t.wcf = {})),
      (u = e.utils || (e.utils = {})),
      (r = u.number || (u.number = {})),
      ((n = r.LengthUnit || (r.LengthUnit = {}))[(n.Millimeter = 0)] =
        'Millimeter'),
      (n[(n.Centimeter = 1)] = 'Centimeter'),
      (n[(n.Inch = 2)] = 'Inch'),
      (n[(n.Feet = 3)] = 'Feet'),
      (n[(n.Meter = 4)] = 'Meter'),
      (n[(n.Kilometer = 5)] = 'Kilometer'),
      (r.isNumber = function (t) {
        return 'number' == typeof t || t instanceof Number;
      }),
      (r.fromLocaleString = l),
      (r.toLocaleString = function (t, e, r, n, o) {
        if (
          (void 0 === r && (r = 3),
          void 0 === n && (n = 3),
          void 0 === o && (o = !1),
          null == t || null == e)
        )
          throw new Error(u.ERR_INVALID_ARGUMENT);
        try {
          return t.toLocaleString(e, {
            useGrouping: o,
            minimumFractionDigits: r,
            maximumFractionDigits: n,
          });
        } catch (t) {
          return null;
        }
      }),
      (r.toLocaleCurrencyString = function (t, e, r, n) {
        if (null == t || null == e || null == r)
          throw new Error(u.ERR_INVALID_ARGUMENT);
        var o = null == n || !0 === n.useGrouping,
          i = null == n || !0 === n.showCurrency,
          s = {
            useGrouping: o,
            currency: e,
            currencyDisplay: 'code',
            style: 'currency',
          };
        try {
          if (i) return t.toLocaleString(r, s);
          if (null == Intl || null == Intl.NumberFormat)
            return t.toLocaleString(r, {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            });
          var a = new Intl.NumberFormat(r, s).resolvedOptions();
          return (
            (a.currency = void 0), (a.style = 'decimal'), t.toLocaleString(r, a)
          );
        } catch (t) {
          return null;
        }
      }),
      (r.fromLocaleLengthString = function (t, e) {
        if ((void 0 === e && (e = 4), null == t))
          throw new Error(u.ERR_INVALID_ARGUMENT);
        for (var r = -1, n = t.length - 1; 0 <= n; --n) {
          var o = t.charCodeAt(n);
          if ((48 <= o && o <= 57) || 46 === o || 44 === o) {
            r = n;
            break;
          }
        }
        if (r < 0) return null;
        var i = t.substring(0, r + 1),
          s = e;
        switch (
          t
            .substring(r + 1)
            .toLowerCase()
            .trim()
        ) {
          case 'mm':
            s = 0;
            break;
          case 'cm':
            s = 1;
            break;
          case 'in':
          case "''":
          case '"':
            s = 2;
            break;
          case 'ft':
          case "'":
            s = 3;
            break;
          case 'm':
            s = 4;
            break;
          case 'km':
            s = 5;
        }
        var a = l(i);
        return null == a ? null : c(a, s, 4);
      }),
      (r.toLocaleLengthString = function (t, e, r, n) {
        if (
          (void 0 === r && (r = 4),
          void 0 === n && (n = !0),
          null == t || null == e)
        )
          throw new Error(u.ERR_INVALID_ARGUMENT);
        var o = c(t, 2, r),
          i = 'm',
          s = 2;
        switch (r) {
          case 0:
            (i = 'mm'), (s = 0);
            break;
          case 1:
            (i = 'cm'), (s = 0);
            break;
          case 2:
            (i = '"'), (s = 1);
            break;
          case 3:
            (i = "'"), (s = 2);
            break;
          case 4:
            (i = 'm'), (s = 2);
            break;
          case 5:
            (i = 'km'), (s = 5);
        }
        try {
          var a = o.toLocaleString(e, {
            useGrouping: !1,
            minimumFractionDigits: s,
            maximumFractionDigits: s,
          });
          return null != a && n && (a += ' ' + i), a;
        } catch (t) {
          return null;
        }
      }),
      (r.convertLengthUnit = c);
  })((egr = egr || {})),
  (function (t) {
    var e, n, r;
    function o(t) {
      return null != t && ('object' == typeof t || t instanceof Object);
    }
    (e = t.wcf || (t.wcf = {})),
      (n = e.utils || (e.utils = {})),
      ((r = n.object || (n.object = {})).isObject = o),
      (r.isPlainObject = function (t) {
        if (!o(t)) return !1;
        if ('[object Object]' !== Object.prototype.toString.call(t)) return !1;
        var e = Object.getPrototypeOf(t);
        return null === e || e === Object.prototype;
      }),
      (r.isNullOrEmpty = function (t) {
        if (null == t) return !0;
        for (var e in t) if (t.hasOwnProperty(e)) return !1;
        return !0;
      }),
      (r.toMap = function (t) {
        if (null == t) throw new Error(n.ERR_INVALID_ARGUMENT);
        var e = new Map();
        for (var r in t) e.set(r, t[r]);
        return e;
      }),
      (r.fromMap = function (t) {
        if (null == t) throw new Error(n.ERR_INVALID_ARGUMENT);
        var r = {};
        return (
          t.forEach(function (t, e) {
            r[e] = t;
          }),
          r
        );
      }),
      (r.shallowEqual = function (t, e) {
        if (t === e) return !0;
        if (null == t || null == e) return !1;
        var r = Object.keys(t),
          n = Object.keys(e);
        if (r.length !== n.length) return !1;
        for (var o = 0, i = r; o < i.length; o++) {
          var s = i[o];
          if (t[s] !== e[s]) return !1;
        }
        return !0;
      });
  })((egr = egr || {})),
  (function (t) {
    var e, i, r;
    function n(t) {
      return null == t || '' === t;
    }
    function o(t) {
      if (null == t) throw new Error(i.ERR_INVALID_ARGUMENT);
      return t.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function s(t) {
      if ('undefined' != typeof TextEncoder) return new TextEncoder().encode(t);
      for (
        var e = t.length,
          r = -1,
          n = new Uint8Array(3 * e),
          o = 0,
          i = 0,
          s = 0;
        s !== e;

      ) {
        if (((o = t.charCodeAt(s)), (s += 1), 55296 <= o && o <= 56319)) {
          if (s === e) {
            (n[(r += 1)] = 239), (n[(r += 1)] = 191), (n[(r += 1)] = 189);
            break;
          }
          if (!(56320 <= (i = t.charCodeAt(s)) && i <= 57343)) {
            (n[(r += 1)] = 239), (n[(r += 1)] = 191), (n[(r += 1)] = 189);
            continue;
          }
          if (
            ((s += 1), 65535 < (o = 1024 * (o - 55296) + i - 56320 + 65536))
          ) {
            (n[(r += 1)] = 240 | (o >>> 18)),
              (n[(r += 1)] = 128 | ((o >>> 12) & 63)),
              (n[(r += 1)] = 128 | ((o >>> 6) & 63)),
              (n[(r += 1)] = 128 | (63 & o));
            continue;
          }
        }
        o <= 127
          ? (n[(r += 1)] = 0 | o)
          : (o <= 2047
              ? (n[(r += 1)] = 192 | (o >>> 6))
              : ((n[(r += 1)] = 224 | (o >>> 12)),
                (n[(r += 1)] = 128 | ((o >>> 6) & 63))),
            (n[(r += 1)] = 128 | (63 & o)));
      }
      return n.subarray(0, r + 1);
    }
    (e = t.wcf || (t.wcf = {})),
      (i = e.utils || (e.utils = {})),
      ((r = i.string || (i.string = {})).isString = function (t) {
        return 'string' == typeof t || t instanceof String;
      }),
      (r.isNullOrEmpty = n),
      (r.isNotNullOrEmpty = function (t) {
        return null != t && '' !== t;
      }),
      (r.trim = function (t, e) {
        if ((void 0 === e && (e = ' '), null == t))
          throw new Error(i.ERR_INVALID_ARGUMENT);
        var r = o(e);
        return t.replace(new RegExp('^' + r + '+|' + r + '+$', 'g'), '');
      }),
      (r.trimLeft = function (t, e) {
        if ((void 0 === e && (e = ' '), null == t))
          throw new Error(i.ERR_INVALID_ARGUMENT);
        var r = o(e);
        return t.replace(new RegExp('^' + r + '+'), '');
      }),
      (r.trimRight = function (t, e) {
        if ((void 0 === e && (e = ' '), null == t))
          throw new Error(i.ERR_INVALID_ARGUMENT);
        var r = o(e);
        return t.replace(new RegExp(r + '+$'), '');
      }),
      (r.compare = function (t, e) {
        return t < e ? -1 : e < t ? 1 : 0;
      }),
      (r.getFileExtension = function (t) {
        if (null == t) throw new Error(i.ERR_INVALID_ARGUMENT);
        var e = t.lastIndexOf('.');
        return e < 0 ? '' : t.slice(e);
      }),
      (r.getFilePath = function (t) {
        if (null == t) throw new Error(i.ERR_INVALID_ARGUMENT);
        var e = t.lastIndexOf('/');
        return e < 0 ? '' : t.slice(0, e + 1);
      }),
      (r.getFileName = function (t) {
        if (null == t) throw new Error(i.ERR_INVALID_ARGUMENT);
        var e = t.lastIndexOf('/');
        return e < 0 ? '' : t.slice(e + 1);
      }),
      (r.joinPath = function () {
        for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
        if (0 === t.length) return '';
        for (var r = new Array(), n = 0, o = t; n < o.length; n++) {
          var i = o[n];
          i.startsWith('/') && (i = i.slice(1)),
            i.endsWith('/') && (i = i.slice(0, -1)),
            r.push(i);
        }
        var s = r.join('/');
        return (
          t[0].startsWith('/') && (s = '/' + s),
          t[t.length - 1].endsWith('/') && (s += '/'),
          s
        );
      }),
      (r.getUrlParamValue = function (t, e) {
        if (null == t || null == e) throw new Error(i.ERR_INVALID_ARGUMENT);
        var r = new RegExp('[?|&]' + e + '=([^&;]+?)(&|#|;|$)').exec(t);
        if (null != r && 1 < r.length) {
          var n = r[1].replace(/\+/g, '%20');
          return decodeURIComponent(n);
        }
        return null;
      }),
      (r.fromBlob = function (n, o) {
        return (
          void 0 === o && (o = !1),
          null == n
            ? Promise.reject(new Error(i.ERR_INVALID_ARGUMENT))
            : new Promise(function (t, e) {
                var r = new FileReader();
                (r.onload = function () {
                  t(r.result);
                }),
                  (r.onerror = function () {
                    null != r.error
                      ? e(
                          new Error('Failed to read from blob: ' + r.error.name)
                        )
                      : e(new Error('Failed to read from blob.'));
                  }),
                  o ? r.readAsDataURL(n) : r.readAsText(n);
              })
        );
      }),
      (r.isDataUri = function (t) {
        return !n(t) && !(t.length < 5) && 'data:' === t.substr(0, 5);
      }),
      (r.htmlEscape = function (t) {
        if (null == t) throw new Error(i.ERR_INVALID_ARGUMENT);
        return t
          .replace(/&/g, '&amp;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/\//g, '&#x2F;');
      }),
      (r.htmlUnescape = function (t) {
        if (null == t) throw new Error(i.ERR_INVALID_ARGUMENT);
        return t
          .replace(/&quot;/g, '"')
          .replace(/&#39;/g, "'")
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&amp;/g, '&')
          .replace(/&#x2F;/g, '/');
      }),
      (r.regExpEscape = o),
      (r.generateRandomUUID = function () {
        var e = window.crypto || window.msCrypto;
        return ('' + 1e7 + -1e3 + -4e3 + -8e3 + -1e11).replace(
          /[018]/g,
          function (t) {
            return (
              t ^
              (e.getRandomValues(new Uint8Array(1))[0] & (15 >> (t / 4)))
            ).toString(16);
          }
        );
      }),
      (r.hash = function (r, n) {
        return __awaiter(this, void 0, void 0, function () {
          var e;
          return __generator(this, function (t) {
            return (e = s(r)), [2, i.arraybuffer.hash(e, n)];
          });
        });
      }),
      (r.encodeToUtf8 = s);
  })((egr = egr || {}));
